<div class="signin-bg">
    <div class="signin-header">
        <div class="signin-title">
            <img src="../../../../assets/images/logo_large.svg" alt="" loading="lazy">
        </div>
        <div class="signin-subtitle mt-3">Access your control center</div>
      </div>
  <div class="signin-card">

    <form [formGroup]="loginForm">
      <div class="signin-form-title">Sign In</div>
      <div class="form-group mb-3">
        <label for="emailInput">Email</label>
        <input type="email" formControlName="email" class="form-control" id="emailInput" placeholder="Enter your email">
        <div *ngIf="loginForm.controls['email'].invalid && (loginForm.controls['email'].dirty || loginForm.controls['email'].touched)" class="error-message">
          <div *ngIf="loginForm.controls['email'].errors.required">
            *Email is required.
          </div>
          <div *ngIf="loginForm.controls['email'].errors.pattern">
            *Invalid email.
          </div>
        </div>
      </div>
      <div class="form-group mb-3 position-relative">
        <label for="passwordInput">Password</label>
        <input 
          [type]="show ? 'text' : 'password'" 
          formControlName="password" 
          class="form-control" 
          id="passwordInput" 
          placeholder="Enter your password"
        >
        

        <img 
          *ngIf="!show" 
          (click)="password()" 
          class="show_hide_password" 
          src="../../../../assets/images/hide.png" 
          alt="Show Password" 
          loading="lazy"
        >
        <img 
          *ngIf="show" 
          (click)="password()" 
          class="show_hide_password" 
          src="../../../../assets/images/view.png" 
          alt="Hide Password" 
          loading="lazy"
        >
      

        <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)" class="error-message">
          <div *ngIf="loginForm.controls['password'].errors.required">
            *Password is required.
          </div>
          <div *ngIf="loginForm.controls['password'].errors.minlength">
            *Minimum password length is 6.
          </div>
        </div>
      </div>
      
      <button class="btn mt-1" [disabled]="!loginForm.valid" (click)="login()">Sign In</button>
    </form>
  
  </div>   
</div>
<app-spinner *ngIf="isLoading" [type]="'normal'"></app-spinner>
        